import RedactText from "../optout-general-components/redacttext";
import { optoutpagetext, serviceCards } from "src/data/aiOptOut";
import ServiceCard from "../cards/servicecard";
import Image from "next/image";
import Link from "next/link";

export default function OptOutListingPage() {
  return (
    <>
      <div className="flex w-full items-end justify-center mt-24 h-24 sm:mt-28">
        <Link href="/ai-optout">
          <Image
            src={require("/public/images/aiOptOut/common/aiOptOut-logo.svg")}
            alt="Redact Logo"
            className=""
            width={200}
            height={123}
            priority
          />
        </Link>
      </div>
      <div className="flex w-full items-end justify-center mt-16 text-center">
        <RedactText
          color="text-redactWhite font-bold font-sans"
          size="sm:text-[51px] text-[40px]"
          text={`${optoutpagetext.Title}`}
        />
      </div>
      <div className="flex w-full items-end justify-center mt-16">
        <div className="sm:w-[51%] w-[80%] text-center">
          <RedactText
            color="text-redactWhite font-bold"
            size="text-[19px]"
            text={`${optoutpagetext.OptOutServices}`}
          />
        </div>
      </div>
      <div className="flex w-full items-end justify-center mt-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 ">
          {serviceCards
            .sort((a, b) => a.order - b.order)
            .map((card) => {
              return (
                <ServiceCard
                  key={card.order}
                  imagePath={card.imagePath.toString()}
                  isButton={true}
                  url={"/ai-optout-instructions/" + card.name.toString()}
                  logoWidth={card.width}
                  logoHeight={card.height}
                />
              );
            })}
        </div>
      </div>
      <div className="mt-20" />
    </>
  );
}
